import React from "react"
// import postlist from "../posts.json"
import { Link, redirect } from "react-router-dom"
import { useParams } from "react-router-dom"
import Markdown from "markdown-to-jsx"
import { Footer } from "../components/Footer/Footer"


const Bradcum = ({title}) => {
    return(
            <>
                <nav className="my-3" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <Link to={'/'} class="breadcrumb-item active" aria-current="page">Home</Link>
                        <li class="breadcrumb-item active" aria-current="page">{title}</li>
                    </ol>
                </nav>          
                <br/>
            </>
    )
}

const PostLink = ({title, id, blogs}) => {
    return(
        <Link to={`/Blog/${id}`} blogs={blogs} style={{color: 'white'}} className="post-link list-group-item text-ligth bg-dark border-0">{title}</Link>
    )
}

const SiderBarpost = (props) => {
    return(
        <nav className="col-md-4">
        <div style={{minHeight: '300px'}} className="sidebar bg-dark text-ligth rounded min-height-50 p-3">
                <h4 className="text-white">Ultimas entradas</h4>
                <ul className="list-group rounded text-ligth">
                    {props.blogs.map((post,i)=>{
                        return(<PostLink blogs={props.blogs} title={post.title} id={post.id}/>)
                    })}
                </ul>
                </div>
        </nav>
    )
}

//MARKDOWN COMPONENTES

const ParrafoPost = ({children}) =>{
    return(
        <div className="w-100 d-flex aling-items-center justify-content-center">
            <p style={{textAlign: 'justify'}} className="">
            {children}  
            </p>            
        </div>

    )
}



const BodyPost = ({title, author, date, content, url_image}) => {
    return(
        <div className="col-md-8 bg-white rounded p-3">        
                <div className="post">
                    <h2>{title}</h2>
                    <small>Publicado el {date.toISOString().slice(0, 10)} por {author}</small>
                    <hr/>
                    {
                        ( url_image )
                        ?
                            <img src={url_image} alt={title} style={{"max-width": '100%'}}/>
                        :
                            null
                    }
                    <Markdown options={
                        {
                            overrides:
                            {
                                p: ParrafoPost ,
                            }
                        }
                        }>{content}
                    </Markdown>
                </div>        
        </div>
    )
}

const Post = (props) => {
    const params = useParams();
    if(!params.id){
        return redirect('/')
    }
    const blogs = props.blogs.filter((post, i) => {
        if (params.id === post.id)
        {
            return true;
        }
        else
        {
            return false;
        }
    });
    if ( blogs.length === 0 )
    {
        return null;
    }
    else
    {
        const blog = blogs[0];
        return (
            <>
                <section style={{minHeight: "100vh" }} className="section my-2">
                    <div className="container"> 
                        <Bradcum title={blog.title}/>
                        <div className="row">
                            <BodyPost 
                                title={blog.title} 
                                author={blog.author}
                                date={new Date(blog.publishDate.seconds*1000)}
                                content={blog.content}
                                url_image={blog.url_image}/>
                            <SiderBarpost blogs={props.blogs}></SiderBarpost>
                        </div>
                    </div>
                </section>
                <Footer></Footer>
            </>
        )
    }
}

export default Post